const backBtn = document.querySelector('[data-toggle="back"]');

if (backBtn !== null) {
    backBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.history.back();
    });
}
